<div class="page-wrapper page-wrapper--contactus">
  <img class="effact-circle" src="./../../../assets/images/support-bg.png" alt="Effact" />
  <img class="effact-circle bottom-right" src="./../../../assets/images/support-bg-bottom.png" alt="Effact" />
  <app-banner-section [content]="content"></app-banner-section>
  <app-contact-us-section></app-contact-us-section>
</div>